import script from "./CreatorPermDeleteMember.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorPermDeleteMember.vue?vue&type=script&setup=true&lang=js"

import "./CreatorPermDeleteMember.vue?vue&type=style&index=0&id=40098df7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40098df7"]])

export default __exports__